import { useEffect, useRef, useState } from "react";
import { CgCloseO } from "react-icons/cg";

function Modal({
  content,
  modalId,
  closeModal,
  size,
  title,
  background,
  closeOnClickOutside,
  extraContentCSS,
  customCloseOutsideCondition,
  extraModalStyle,
  onModalUnmount,
  footerBtns,
  isResizable = false, // If a modal is resizable the width and height for the state need to be specified using extraModalStyle
  showCloseBtn = true,
}) {
  const MODAL_FADE_OUT = 280;
  const MODAL_MIN_WIDTH = 200;
  const MODAL_MIN_HEIGHT = 300;

  const [dimensions, setDimensions] = useState({ width: extraModalStyle?.width, height: extraModalStyle?.height });
  const modalRef = useRef(null);

  const handleMouseDown = (e) => {
    e.preventDefault();
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (e) => {
    const newWidth = e.clientX - modalRef.current.getBoundingClientRect().left;
    const newHeight = e.clientY - modalRef.current.getBoundingClientRect().top;
    if (newWidth > MODAL_MIN_WIDTH && newHeight > MODAL_MIN_HEIGHT)
      setDimensions({ width: newWidth, height: newHeight });
  };

  const handleMouseUp = () => {
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  useEffect(() => {
    if (!isResizable) {
      // resize modal content container height when title expands to more than the 50px default
      // ------------
      const resize_ob = new ResizeObserver((entries) => {
        let modalTitleContainer = entries[0].contentRect;
        let titleHeight = modalTitleContainer.height;
        if (entries[1]) entries[1].target.style.height = entries[2].contentRect.height - titleHeight - 50 + "px";
      });

      const parentComponent = document.getElementById(modalId);

      resize_ob.observe(parentComponent.getElementsByClassName("modal-title")[0]);
      resize_ob.observe(parentComponent.querySelector("#modal-data"));
      resize_ob.observe(parentComponent);

      // ------------
    }

    if (closeOnClickOutside === true) {
      const closeModalEvent = function (event) {
        if (
          document.getElementById("dismissible-toast-container").contains(event.target) // prevent propagation on notifications events
        ) {
          return;
        }
        if (
          (customCloseOutsideCondition !== undefined ? customCloseOutsideCondition(event) : true) &&
          !event.target.closest("#" + modalId)
        ) {
          document.getElementById(modalId).classList.add("fadeOut");
          setTimeout(() => {
            closeModal();
          }, MODAL_FADE_OUT); // A little less then the time of the fade out animation for smooth transition
        }
      };
      document.addEventListener("click", closeModalEvent, true);
      return () => {
        if (onModalUnmount !== undefined) {
          onModalUnmount();
        }
        document.removeEventListener("click", closeModalEvent, true);
      };
    }
  }, []);
  return (
    <div className={background === undefined || background === true ? "modal" : "modal-no-background"}>
      <div
        id={modalId}
        className={`${size}-modal modal-content`}
        style={isResizable ? { width: dimensions.width, height: dimensions.height } : { ...extraModalStyle }}
        ref={modalRef}
        onClick={(e) => {
          if (isResizable) e.stopPropagation();
        }}
      >
        <div className="modal-title">
          <div className="modal-title-text">{title}</div>
          <button
            className="close-modal-btn"
            onClick={() => {
              closeModal();
            }}
          >
            <CgCloseO size={25} />
          </button>
        </div>
        <div id="modal-data" className={`modal-data ${extraContentCSS}`}>
          {content}
        </div>
        <div
          id={`modal-footer-${modalId}`}
          className={`modal-footer ${!showCloseBtn ? "modal-footer-no-close-btn" : ""}`}
        >
          {footerBtns !== undefined &&
            footerBtns.map((btn) => {
              const { id, title, btnCSS } = btn;
              return (
                <button key={id} className={btnCSS}>
                  {title}
                </button>
              );
            })}
          {showCloseBtn && (
            <button
              className="footer-close-modal-btn"
              onClick={() => {
                closeModal();
              }}
            >
              Close
            </button>
          )}
        </div>
        {isResizable && <div className="modal-resize-handle" onMouseDown={handleMouseDown}></div>}
      </div>
    </div>
  );
}

export default Modal;
